import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  List,
  ListItem,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {useTranslation} from 'react-i18next';

interface ServicePointInfoDialogProps {
  open: boolean;
  onClose: () => void;
}

const ServicePointInfoDialog: React.FC<ServicePointInfoDialogProps> = ({open, onClose}) => {
  const {t} = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          bgcolor: 'background.default',
          backgroundImage: 'none'
        }
      }}
    >
      <DialogTitle>{t('servicePointInfo.title')}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={{xs: 12, md: 6}} sx={{order: {xs: 2, md: 1}}}>
            <Typography variant="h6" component="h2" sx={{mb: 1, fontWeight: 'medium'}}>
              {t("servicePointInfo.new.title")}
            </Typography>
            <img
              src='/images/tf_sim_gray.jpg'
              alt={t("servicePointInfo.new.title")}
              style={{maxHeight: 200, height: 'auto', maxWidth: '100%', width: 'auto'}}
            />
            <Typography variant="subtitle1" component="h3" sx={{mt: 2}}>
              <strong>APN:</strong> iot.telefonica.de
            </Typography>
            <List
              sx={{
                listStyleType: 'disc',
                listStylePosition: 'inside',
              }}
            >
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Funktioniert mit allen Semitron-Geräten</ListItem>
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>
                Funktioniert mit HALE MCT07, aber APN manuell setzen unter 👉 http://172.16.1.1/
              </ListItem>
            </List>
          </Grid>
          <Grid size={{xs: 12, md: 6}} sx={{order: {xs: 1, md: 2}}}>
            <Typography variant="h6" sx={{mb: 1, fontWeight: 'medium'}}>
              {t("servicePointInfo.old.title")}
            </Typography>
            <img
              src='/images/tf_sim_blue.jpg'
              alt={t("servicePointInfo.old.title")}
              style={{maxHeight: 200, height: 'auto', maxWidth: '100%', width: 'auto'}}
            />
            <Typography variant="subtitle1" component="h3" sx={{mt: 2}}>
              <strong>APN:</strong> iotde.telefonica.com
            </Typography>
            <List
              sx={{
                listStyleType: 'disc',
                listStylePosition: 'inside',
              }}
            >
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Funktioniert mit allen Semitron-Geräten</ListItem>
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Funktioniert mit allen HALE-Geräten</ListItem>
            </List>
          </Grid>
          <Grid size={{xs: 12}} sx={{order: {xs: 3}}}>
            <Typography variant="subtitle1" component="h3" sx={{fontWeight: 600}}>
              Manuelle Netz-Einstellungen (neu):
            </Typography>
            <List
              sx={{
                listStyleType: 'disc',
                listStylePosition: 'inside',
              }}
            >
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>MCC: 262</ListItem>
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>MNC: 03</ListItem>
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Benutzername: leer lassen</ListItem>
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Passwort: leer lassen</ListItem>
            </List>
            <Typography variant="subtitle1" component="h3" sx={{fontWeight: 600}}>
              Hinweise:
            </Typography>
            <List
              sx={{
                listStyleType: 'disc',
                listStylePosition: 'inside',
              }}
            >
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Nach jeder APN- oder Netz-Einstellung das Gerät neu
                starten</ListItem>
              <ListItem sx={{display: "list-item", pl: 0, pt: 0}}>Nur die oben genannten Felder anpassen; übrige Werte
                unverändert lassen</ListItem>
            </List>
          </Grid>
          <Grid size={{xs: 12}} sx={{order: {xs: 4}}}>
            <Typography variant="h6" sx={{mb: 1, fontWeight: 'medium'}}>
              HALE MCT06 & SPT02 – PROGRAMMIERUNG
            </Typography>
            <Typography variant="subtitle1" component="h3" sx={{fontWeight: 600}}>
              Fahrten-Speicher (F283):
            </Typography>
            <Typography variant="body1">
              Für die Taxameter-Modelle MCT-06 und SPT-02 den Parameter auf Wert 198 setzen.<br />
              ➡️ Diese Einstellung ist erforderlich für die korrekte Datenspeicherung mit TaxiFusion.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{p: 2}}>
        <Button onClick={onClose} variant="contained">{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
export default ServicePointInfoDialog;
